export const VERTICAL_POSITION_MAP = {
  top: "flex-start",
  middle: "center",
  bottom: "flex-end",
};

export const HORIZONTAL_POSITION_MAP = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
};

export const FORMATS_WITH_CONTAINER = ["rectangle", "square"];

export const isYouTubeUrl = (url) => {
  const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+$/;
  return youtubeRegex.test(url);
};

export const getYouTubeVideoId = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};

export const calculateWidth = (item) => {
  const hasWidth = item.width != null;
  const hasMaxWidth = item.max_width != null;
  const hasSizePct = item.size != null;
  const hasMaxWidthPct = item.max_width_pct_component != null;

  // Prefer percentage size when present (single Size slider UX)
  if (hasSizePct) {
    return item.size;
  }
  if (hasMaxWidthPct) {
    return item.max_width_pct_component;
  }

  if (hasWidth) {
    let candidate = item.width;
    if (hasMaxWidth) {
      candidate = Math.min(candidate, item.max_width);
    }
    return candidate;
  }

  if (hasMaxWidth) {
    return item.max_width;
  }

  return null;
};

export const calculateHeight = (item) => {
  if (item.height != null && item.max_height != null) {
    return Math.min(item.height, item.max_height);
  } else if (item.height != null) {
    return item.height;
  } else if (item.max_height != null) {
    return item.max_height;
  }
  return null;
};

export const getPositionStyles = (position = "middle-center") => {
  const [vertical = "middle", horizontal = "center"] = position.split("-");
  return {
    justifyContent: HORIZONTAL_POSITION_MAP[horizontal] || horizontal,
    alignItems: VERTICAL_POSITION_MAP[vertical] || vertical,
  };
};
